export const SuccessOpenIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M9.40625 5.6875L6.19609 8.75L4.59375 7.21875"
      stroke="#4FCC88"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.10051 9.8995 1.75 7 1.75C4.10051 1.75 1.75 4.10051 1.75 7C1.75 9.8995 4.10051 12.25 7 12.25Z"
      stroke="#4FCC88"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
